import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'partner-mart-locations-header',
    templateUrl: './partner-mart-locations-header.component.html',
    styleUrls: ['./partner-mart-locations-header.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsHeaderComponent {
    @Input() public store: any = {};
}
